module.exports = __webpack_public_path__ + "static/media/spos4.3daccd54.png";